import React, { PureComponent, Fragment } from 'react';
import { withRouter } from "react-router-dom";
import { connect } from 'react-redux';

import { Card, CardBody, Row, Col } from 'reactstrap';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Checkbox from '@material-ui/core/Checkbox';

import MatAppBar from '../../../shared/components/building_filters/UnitsSearchAppBar';

import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import ListViewIcon from 'mdi-react/FormatListBulletedIcon';
import GridViewIcon from 'mdi-react/ViewModuleIcon';
import ColumnsIcon from 'mdi-react/ViewColumnIcon';

import LinearLoading from '../../../shared/components/LinearLoading';
import StickyScrollbar from '../../../shared/components/StickyScrollbar';
import BuildingIcons from '../../../shared/components/BuildingIcons';
import AddCollectionButton from '../../../shared/components/collections/AddCollectionButton';

import SegmentSelector from './SegmentSelector';

import { isMobile } from "react-device-detect";

import { Tooltip } from '@material-ui/core';
import moment from "moment";
import { _buildingIDs, _axiosCall } from '../../../shared/helpers/apicalls';
import {
	_capitalizeText,
	_formatNumber,
	_formatDimension,
	_formatPrice,
	_nameToUrl,
	_shouldShow,
	_getBuildingURL,
	buildingFL,
	propertySearchFL,
	SalesProgress,
	BuildingStatus,
	_isEqual,
	_tranformTagsQuery,
	syncURLFilters,
	syncURLSearch,
	setURLFromState,
	setLocalStorage,
	getLocalStorage,
	deleteLocalStorage,
	syncStageFilters,
	syncGenericFilter,
	_objectEqual,
	buildingExportFL,
	getCohortQuery,
	getBuildingsCohortForStatuses,
	CurrentStatus,
	BuildingPhoto,
	_getBuildingPhotos,
	_replaceAbbreviations,
} from "../../../shared/helpers/utils";

import {
	_propertySearchFilters,
	_buildingAdminFilters,
	_buildingStageFilter,
} from "../../../shared/helpers/filters";

import { _hasPermission	} from "../../../shared/helpers/access";
import queryString from "query-string";

// Reuse from PropertySearch
import MatTableHead from '../../PropertySearch/components/MatTableHead';
import ColumnSelector from '../../PropertySearch/components/ColumnSelector';
import PropertyGridView from '../../PropertySearch/components/PropertyGridView';
import ToggleChips from '../../PropertySearch/components/ToggleChips';

const buildingUrl = process.env.API_ROOT + '/query/';

const subFilterKey = 'subFilters';
const buildingStagesKey = 'buildingStages';
const columnsKey = 'visibleColumns';

// --- Shared helper: recursively flatten hierarchical filter values ---
const flattenFilterValues = (filterDef) => {
	const flatten = (items) => {
		let flat = [];
		items.forEach(item => {
			if (item.children && item.children.length > 0) {
				flat = [...flat, ...flatten(item.children)];
			} else if (item.search_value !== "") {
				flat.push(item);
			}
		});
		return flat;
	};
	return flatten(filterDef.values);
};

// --- Building Class Short Descriptions ---
const buildingClassDesc = {"A":"1-Fam","A0":"Cape Cod","A1":"2-Story Detached","A2":"1-Story Perm","A3":"Lg Suburban","A4":"City 1-Fam","A5":"1-Fam Attach/Semi","A6":"Summer Cottage","A7":"Mansion/Townhouse","A8":"Bungalow Colony","A9":"Misc 1-Fam","B":"2-Fam","B1":"2-Fam Brick","B2":"2-Fam Frame","B3":"2-Fam Convert","B9":"Misc 2-Fam","C":"Walk-Up Apt","C0":"3-Fam","C1":"6+ Fam No Store","C2":"5-6 Fam","C3":"4-Fam","C4":"Old Law Tenement","C5":"Convert/Rooming","C6":"Walk-Up Co-op","C7":"6+ Fam W/Store","C8":"Walk-Up Co-op Loft","C9":"Garden Apt","CB":"Walk-Up <11 Units","CC":"Walk-Up Co-op <11","CM":"Mobile Home","D":"Elev Apt","D0":"Elev Co-op Loft","D1":"Elev Semi-FP No Store","D2":"Elev Artist","D3":"Elev FP No Store","D4":"Elev Co-op","D5":"Elev Convert","D6":"Elev FP W/Store","D7":"Elev Semi-FP W/Store","D8":"Elev Luxury","D9":"Elev Misc","DB":"Elev <11 Units","DC":"Elev Co-op <11","E":"Warehouse","E1":"Gen Warehouse","E2":"Contractor Whse","E7":"Self-Storage","E9":"Misc Warehouse","F":"Factory/Indust","F1":"Heavy Mfg FP","F2":"Special Constr FP","F4":"Indust Semi-FP","F5":"Light Mfg","F8":"Tank Farm","F9":"Misc Industrial","G":"Garage","G0":"Res Garage TC1","G1":"Parking Garage","G2":"Auto Body/Repair","G3":"Gas+Retail","G4":"Gas+Service","G5":"Gas Station","G6":"Licensed Lot","G7":"Unlicensed Lot","G8":"Car Sales Showroom","G9":"Misc Garage","GU":"Car Sales No Show","GW":"Car Wash","H":"Hotel","HB":"Boutique Hotel","HH":"Hostel","HR":"SRO","HS":"Extended Stay","H1":"Luxury Hotel","H2":"Full Svc Hotel","H3":"Ltd Svc Hotel","H4":"Motel","H5":"Private Club Hotel","H6":"Apt Hotel","H7":"Co-op Apt Hotel","H8":"Dorm","H9":"Misc Hotel","I":"Hospital/Health","I1":"Hospital","I2":"Infirmary","I3":"Dispensary","I4":"Hospital Staff","I5":"Health Center","I6":"Nursing Home","I7":"Adult Care","I9":"Misc Health","J":"Theatre","J1":"Art Theatre <400","J2":"Art Theatre 400+","J3":"Movie+Balcony","J4":"Legit Theatre","J5":"Theatre Mixed-Use","J6":"TV Studio","J7":"Off-Broadway","J8":"Multiplex","J9":"Misc Theatre","K":"Store","K1":"1-Story Retail","K2":"Multi-Story Retail","K3":"Dept Store","K4":"Retail+Other","K5":"Food Estab","K6":"Shopping Center","K7":"Bank","K8":"Big Box Retail","K9":"Misc Store","L":"Loft","L1":"Loft 8+ Story","L2":"Loft FP Storage","L3":"Loft Semi-FP","L8":"Loft W/Retail","L9":"Misc Loft","M":"Religious","M1":"Church/Synagogue","M2":"Mission House","M3":"Parsonage","M4":"Convent","M9":"Misc Religious","N":"Asylum/Home","N1":"Asylum","N2":"Indigent Home","N3":"Orphanage","N4":"Detention House","N9":"Misc Asylum","O":"Office","O1":"Office 1-Story","O2":"Office 2-6 Story","O3":"Office 7-19 Story","O4":"Office 20+ Story","O5":"Office+Comm 1-6","O6":"Office+Comm 7-19","O7":"Prof Bldg/Funeral","O8":"Office+Apt","O9":"Misc Office/Bank","P":"Public Assembly","P1":"Concert Hall","P2":"Lodge Room","P3":"Y/PAL","P4":"Beach Club","P5":"Community Ctr","P6":"Amusement/Bath","P7":"Museum","P8":"Library","P9":"Misc Assembly","Q":"Outdoor Rec","Q1":"Park/Rec","Q2":"Playground","Q3":"Outdoor Pool","Q4":"Beach","Q5":"Golf Course","Q6":"Stadium/Track","Q7":"Tennis Court","Q8":"Marina/Yacht","Q9":"Misc Outdoor Rec","R":"Condo","RA":"Condo Cultural/Med","RB":"Condo Office","RG":"Condo Parking","RH":"Condo Hotel","RK":"Condo Retail","RP":"Condo Outdoor Pkg","RR":"Condo Rental","RS":"Condo Storage","RT":"Condo Terrace","RW":"Condo Whse/Indust","R0":"Condo Billing Lot","R1":"Condo Res 2-10","R2":"Condo Walk-Up","R3":"Condo 1-3 Story","R4":"Condo Elevator","R5":"Condo Misc Comm","R6":"Condo Res 1-3 TC1","R7":"Condo Comm 1-3 TC1","R8":"Condo Comm 2-10","R9":"Co-op in Condo","S":"Res Mixed-Use","S0":"1-Fam+2 Store","S1":"1-Fam+1 Store","S2":"2-Fam+1 Store","S3":"3-Fam+1 Store","S4":"4-Fam+1 Store","S5":"5-6 Fam+1 Store","S9":"Dwelling+Store","T":"Transport","T1":"Airport","T2":"Pier/Dock","T9":"Misc Transport","U":"Utility","U0":"Utility Land/Bldg","U1":"Bridge/Tunnel","U2":"Gas/Electric","U3":"Ceiling Railroad","U4":"Telephone","U5":"Comm Facility","U6":"Private Railroad","U7":"Public Transport","U8":"Revocable Consent","U9":"Misc Utility","UR":"Util Rev Consent","V":"Vacant","V0":"Vacant Res Non-MN","V1":"Vacant Comm/MN Res","V2":"Vacant Comm Adj TC1","V3":"Vacant Prim Res","V4":"Vacant Police/Fire","V5":"Vacant School","V6":"Vacant Lib/Hosp","V7":"Vacant Port Auth","V8":"Vacant NYS/US Gov","V9":"Misc Vacant","VG":"Comm Garden Res","VC":"Comm Garden Comm","W":"Education","W1":"Public School","W2":"Parochial/Yeshiva","W3":"School/Academy","W4":"Training School","W5":"City University","W6":"College/Univ","W7":"Seminary","W8":"Private School","W9":"Misc Education","Y":"Government","Y1":"Fire Dept","Y2":"Police Dept","Y3":"Prison/Jail","Y4":"Military","Y5":"Dept Real Estate","Y6":"Dept Sanitation","Y7":"Dept Ports","Y8":"Dept Public Works","Y9":"Dept Env Protect","Z":"Misc Bldg","Z0":"Court/Pool/Shed","Z1":"Court House","Z2":"Public Parking","Z3":"Post Office","Z4":"Foreign Gov","Z5":"United Nations","Z7":"Easement","Z8":"Cemetery","Z9":"Other Misc"};

// --- Quick filter chips (only for 'all' segment) ---
const allChipData = [
	{ key: 0, label: "Residential", filter: { property_type_filter: ["A0","A1","A2","A3","A4","A5","A6","A7","A8","A9","B1","B2","B3","B9","C0","C3","XC8","XD0","XD4","XC6","XCC","XDC","RD","R0","C4","RT"] } },
	{ key: 1, label: "Multi-Family", filter: { property_type_filter: ["C2","D1","D2","D3","D5","D8","D9","C9","CB","DB","H8","HR","CM"] } },
	{ key: 2, label: "Office", filter: { property_type_filter: ["O1","O2","O3","O4","O5","O6","O7","RB","K7","O9","J6","Z1"] } },
	{ key: 3, label: "New Construction", filter: { min_year_built: "2019" } },
];

// --- Segment Configurations ---
const SEGMENT_CONFIGS = {
	condos: {
		fieldList: buildingFL,
		defaultSort: 'inventory_unsold',
		defaultOrder: 'desc',
		defaultSubFilter: {offering_verified_status:["not-abandoned"]},
		lsPrefix: 'BU_condos_',
		hasBuildingStages: true,
		defaultStages: ['sponsor'],
		hasHierarchicalFilter: false,
		hasToggleChips: false,
		showCondoColumns: true,
	},
	rental: {
		fieldList: propertySearchFL,
		defaultSort: 'active_listings_rent',
		defaultOrder: 'desc',
		defaultSubFilter: { property_type_filter: ["C1","C2","D1","D2","D3","D5","D8","D9","C9","CB","DB"] },
		lsPrefix: 'BU_rental_',
		hasBuildingStages: false,
		defaultStages: [],
		hasHierarchicalFilter: true,
		hasToggleChips: false,
		showCondoColumns: false,
	},
	commercial: {
		fieldList: propertySearchFL,
		defaultSort: 'total_building_floor_area',
		defaultOrder: 'desc',
		defaultSubFilter: { property_type_filter: ["O1","O2","O3","O4","O5","O6","O7","RB","K7","O9","J6","Z1","K3","K8","K9","K6","G8","K1","K2","K4","RK","R7","R8"] },
		lsPrefix: 'BU_comm_',
		hasBuildingStages: false,
		defaultStages: [],
		hasHierarchicalFilter: true,
		hasToggleChips: false,
		showCondoColumns: false,
	},
	'multi-family': {
		fieldList: propertySearchFL,
		defaultSort: 'last_sold_date',
		defaultOrder: 'desc',
		defaultSubFilter: { property_type_filter: ["B1","B2","B3","B9","C0","C3","C2"] },
		lsPrefix: 'BU_mf_',
		hasBuildingStages: false,
		defaultStages: [],
		hasHierarchicalFilter: true,
		hasToggleChips: false,
		showCondoColumns: false,
	},
	'vacant-land': {
		fieldList: propertySearchFL,
		defaultSort: 'lot_area',
		defaultOrder: 'desc',
		defaultSubFilter: { property_type_filter: ["V0","V1","V2","V3","V4","V5","V6","V7","V8","V9","VG","VC","Q0"] },
		lsPrefix: 'BU_vl_',
		hasBuildingStages: false,
		defaultStages: [],
		hasHierarchicalFilter: true,
		hasToggleChips: false,
		showCondoColumns: false,
	},
	other: {
		fieldList: propertySearchFL,
		defaultSort: 'total_floors',
		defaultOrder: 'desc',
		defaultSubFilter: {},
		lsPrefix: 'BU_other_',
		hasBuildingStages: false,
		defaultStages: [],
		hasHierarchicalFilter: true,
		hasToggleChips: true,
		showCondoColumns: false,
	},
};

// --- Column Definitions ---
const condoColumns = [
	{ id: 'display_full_street_address', label: 'Address', default: true, locked: true, group: 'general' },
	{ id: 'ownership_type', label: 'Type', default: true, group: 'general' },
	{ id: 'building_status', label: 'Status', default: true, group: 'general' },
	{ id: 'sales_progress', label: 'Sales Progress', default: true, group: 'general', disableSort: true },
	{ id: 'sales_start_date', label: 'Sales Started', default: false, group: 'general' },
	{ id: 'total_units', label: 'Total Units', default: true, group: 'general' },
	{ id: 'residential_units', label: 'Residential Units', default: false, group: 'general' },
	{ id: 'inventory_unsold', label: 'Unsold', default: true, group: 'general' },
	{ id: 'inventory_pct_sold', label: '% Sold', default: false, group: 'general' },
	{ id: 'inventory_stats_listings_average_ppsf', label: 'Avg PPSF (Ask)', default: true, group: 'financial' },
	{ id: 'inventory_stats_transactions_average_ppsf', label: 'Avg PPSF (Sold)', default: true, group: 'financial' },
	{ id: 'year_built', label: 'Year Built', default: true, group: 'general' },
	{ id: 'developers', label: 'Developer', default: true, group: 'general' },
	{ id: 'total_floors', label: 'Stories', default: false, group: 'building' },
	{ id: 'architect', label: 'Architect', default: false, group: 'general' },
	{ id: 'offering_file_number', label: 'Op Number', default: false, group: 'general' },
];

const rentalColumns = [
	{ id: 'display_full_street_address', label: 'Address', default: true, locked: true, group: 'general' },
	{ id: 'ownership_type', label: 'Type', default: true, group: 'general' },
	{ id: 'building_class', label: 'Building Class', default: true, group: 'general' },
	{ id: 'active_listings_rent', label: 'Active Rentals', default: true, group: 'general' },
	{ id: 'residential_units', label: 'Units', default: true, group: 'general' },
	{ id: 'total_floors', label: 'Stories', default: true, group: 'building' },
	{ id: 'total_building_floor_area', label: 'Building SF', default: true, group: 'building' },
	{ id: 'year_built', label: 'Year Built', default: true, group: 'general' },
	{ id: 'lot_area', label: 'Lot SqFt', default: false, group: 'building' },
	{ id: 'buildable_area', label: 'Buildable Area', default: true, group: 'building', disableSort: true },
	{ id: 'developers', label: 'Developer', default: false, group: 'general' },
	{ id: 'owner', label: 'Owner', default: false, group: 'general' },
];

const commercialColumns = [
	{ id: 'display_full_street_address', label: 'Address', default: true, locked: true, group: 'general' },
	{ id: 'building_class', label: 'Building Class', default: true, group: 'general' },
	{ id: 'total_building_floor_area', label: 'Building SF', default: true, group: 'building' },
	{ id: 'total_floors', label: 'Stories', default: true, group: 'building' },
	{ id: 'lot_area', label: 'Lot SqFt', default: true, group: 'building' },
	{ id: 'year_built', label: 'Year Built', default: true, group: 'general' },
	{ id: 'zoning_district_1', label: 'Zoning', default: true, group: 'building' },
	{ id: 'owner', label: 'Owner', default: true, group: 'general' },
	{ id: 'last_sold_price', label: 'Sale Price', default: true, group: 'financial' },
	{ id: 'last_sold_date_formatted', label: 'Sale Date', default: false, group: 'financial' },
	{ id: 'assessed_total_value', label: 'Assessed Total Value', default: false, group: 'financial' },
	{ id: 'built_far', label: 'Built FAR', default: false, group: 'building' },
	{ id: 'max_commercial_far', label: 'Max Com FAR', default: false, group: 'building' },
	{ id: 'buildable_area', label: 'Buildable Area', default: false, group: 'building', disableSort: true },
];

// Reuse from PropertySearch
const otherColumns = [
	{ id: 'display_full_street_address', label: 'Address', default: true, locked: true, group: 'general' },
	{ id: 'building_class', label: 'Building Class', default: true, group: 'general' },
	{ id: 'sq_ft', label: 'SqFt', default: true, group: 'building' },
	{ id: 'owner', label: 'Owner', default: true, group: 'general' },
	{ id: 'year_built', label: 'Year Built', default: true, group: 'general' },
	{ id: 'total_floors', label: 'Stories', default: true, group: 'building' },
	{ id: 'residential_units', label: 'Units', default: false, group: 'general' },
	{ id: 'total_building_floor_area', label: 'Building SF', default: true, group: 'building' },
	{ id: 'lot_area', label: 'Lot SqFt', default: true, group: 'building' },
	{ id: 'zoning_district_1', label: 'Zoning', default: true, group: 'building' },
	{ id: 'buildable_area', label: 'Buildable Area', default: true, group: 'building', disableSort: true },
	{ id: 'last_sold_date_formatted', label: 'Sale Date', default: false, group: 'financial' },
	{ id: 'last_sold_price', label: 'Sale Price', default: false, group: 'financial' },
	{ id: 'ownership_type', label: 'Ownership Type', default: false, group: 'general' },
	{ id: 'zip', label: 'Zip Code', default: false, group: 'general' },
	{ id: 'building_category', label: 'Category', default: false, group: 'building' },
	{ id: 'last_listed_sale_price_all', label: 'Last Listed Price', default: false, group: 'financial' },
	{ id: 'lot_frontage', label: 'Lot Width', default: false, group: 'building' },
	{ id: 'lot_depth', label: 'Lot Depth', default: false, group: 'building' },
	{ id: 'active_listings_sale', label: 'Units for Sale', default: false, group: 'general' },
	{ id: 'active_listings_rent', label: 'Units for Rent', default: false, group: 'general' },
	{ id: 'offering_file_number', label: 'Op Number', default: false, group: 'general' },
	{ id: 'developers', label: 'Developers', default: false, group: 'general' },
	{ id: 'architect', label: 'Architect', default: false, group: 'general' },
	{ id: 'marketing_company', label: 'Marketing Company', default: false, group: 'general' },
	{ id: 'assessed_land_value', label: 'Assessed Land Value', default: false, group: 'financial' },
	{ id: 'assessed_total_value', label: 'Assessed Total Value', default: false, group: 'financial' },
	{ id: 'built_far', label: 'Built FAR', default: false, group: 'building' },
	{ id: 'max_residential_far', label: 'Max Res FAR', default: false, group: 'building' },
	{ id: 'max_commercial_far', label: 'Max Com FAR', default: false, group: 'building' },
	{ id: 'historic_district_name', label: 'Historic District', default: false, group: 'general' },
	{ id: 'school_district', label: 'School District', default: false, group: 'general' },
];

const multiFamilyColumns = [
	{ id: 'display_full_street_address', label: 'Address', default: true, locked: true, group: 'general' },
	{ id: 'building_class', label: 'Building Class', default: true, group: 'general' },
	{ id: 'residential_units', label: 'Units', default: true, group: 'general' },
	{ id: 'total_floors', label: 'Stories', default: true, group: 'building' },
	{ id: 'year_built', label: 'Year Built', default: true, group: 'general' },
	{ id: 'total_building_floor_area', label: 'Building SF', default: true, group: 'building' },
	{ id: 'lot_area', label: 'Lot SqFt', default: true, group: 'building' },
	{ id: 'owner', label: 'Owner', default: true, group: 'general' },
	{ id: 'zoning_district_1', label: 'Zoning', default: false, group: 'building' },
	{ id: 'last_sold_price', label: 'Sale Price', default: false, group: 'financial' },
	{ id: 'last_sold_date_formatted', label: 'Sale Date', default: false, group: 'financial' },
	{ id: 'assessed_total_value', label: 'Assessed Total Value', default: false, group: 'financial' },
	{ id: 'buildable_area', label: 'Buildable Area', default: true, group: 'building', disableSort: true },
];

const vacantLandColumns = [
	{ id: 'display_full_street_address', label: 'Address', default: true, locked: true, group: 'general' },
	{ id: 'building_class', label: 'Building Class', default: true, group: 'general' },
	{ id: 'lot_area', label: 'Lot SqFt', default: true, group: 'building' },
	{ id: 'lot_frontage', label: 'Lot Width', default: true, group: 'building' },
	{ id: 'lot_depth', label: 'Lot Depth', default: true, group: 'building' },
	{ id: 'zoning_district_1', label: 'Zoning', default: true, group: 'building' },
	{ id: 'buildable_area', label: 'Buildable Area', default: true, group: 'building', disableSort: true },
	{ id: 'owner', label: 'Owner', default: true, group: 'general' },
	{ id: 'max_residential_far', label: 'Max Res FAR', default: false, group: 'building' },
	{ id: 'max_commercial_far', label: 'Max Com FAR', default: false, group: 'building' },
	{ id: 'last_sold_price', label: 'Sale Price', default: false, group: 'financial' },
	{ id: 'last_sold_date_formatted', label: 'Sale Date', default: false, group: 'financial' },
	{ id: 'assessed_land_value', label: 'Assessed Land Value', default: false, group: 'financial' },
	{ id: 'assessed_total_value', label: 'Assessed Total Value', default: false, group: 'financial' },
];

const SEGMENT_COLUMNS = {
	condos: condoColumns,
	rental: rentalColumns,
	commercial: commercialColumns,
	'multi-family': multiFamilyColumns,
	'vacant-land': vacantLandColumns,
	other: otherColumns,
};

const getDefaultColumns = (segment) => {
	const cols = SEGMENT_COLUMNS[segment] || otherColumns;
	return cols.filter(col => col.default).map(col => col.id);
};

const getSubFiltersForSegment = (segment, buildingStages) => {
	if (segment === 'condos') {
		const stages = buildingStages && buildingStages.length > 0 ? buildingStages : ['sponsor'];
		return _buildingAdminFilters.filter(filter => {
			if (!filter.exclude_stage) return true;
			// Show filter if ANY selected stage allows it
			return stages.some(stage => filter.exclude_stage.indexOf(stage) < 0);
		});
	}
	return _propertySearchFilters;
};


class BuildingsMatTable extends PureComponent {
	tableWrapRef = React.createRef();


  _getSegment = () => this.props.segment || 'condos';

  _getConfig = () => SEGMENT_CONFIGS[this._getSegment()] || SEGMENT_CONFIGS['other'];

  _getActiveColumns = () => SEGMENT_COLUMNS[this._getSegment()] || otherColumns;

  _getActiveFilters = () => getSubFiltersForSegment(this._getSegment(), this.state ? this.state.buildingStages : []);

  lsPre = () => (SEGMENT_CONFIGS[this.props.segment] || SEGMENT_CONFIGS['other']).lsPrefix;

  state = (() => {
	const segment = this.props.segment || 'condos';
	const config = SEGMENT_CONFIGS[segment] || SEGMENT_CONFIGS['other'];
	const lsPre = config.lsPrefix;
	const filters = getSubFiltersForSegment(segment, config.defaultStages);

	// Parse URL for condos status chips
	const params = queryString.parse(this.props.location ? this.props.location.search : '');
	let initialStages = config.defaultStages;
	if (params.status) {
		initialStages = params.status.split(',');
	}

	return {
		order: config.defaultOrder,
		orderBy: config.defaultSort,
		userSorted: false,
		selected: new Map([]),
		page: 0,
		rowsPerPage: 48,
		buildingsFetchInProgress: false,
		clearInput: false,
		end: 30,
		filterBorough: "all_boroughs",
		filterStage: "all_projects",
		futureInventoryData: false,
		inventoryData: false,
		originalData: false,
		ovelayMinHeight: false,
		reactTableFiltered: [],
		showCounts: {desktop: 3, tablet: 2, mobile: 1},
		start: 0,
		stats: {},
		subFilters: syncURLFilters(this.props, filters, subFilterKey, lsPre, config.defaultSubFilter),
		tableData: false,
		totalUnsoldUnits: false,
		searchText: syncURLSearch(this.props, 'searchText'),
		facetData: null,
		selectedUnits: {},
		buildingStages: config.hasBuildingStages
			? syncStageFilters(this.props, _buildingStageFilter, buildingStagesKey, lsPre, initialStages)
			: [],
		visibleColumns: (() => { try { return JSON.parse(getLocalStorage(lsPre, columnsKey) || 'null') || getDefaultColumns(segment); } catch(e) { return getDefaultColumns(segment); } })(),
		columnSelectorOpen: false,
		viewType: 'list',
	};
  })();

  q = '';
  fq = '';
  sort = '';

  componentDidMount() {
	this._getInventoryStats();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
	// If segment changed via props, reset everything
	if (prevProps.segment !== this.props.segment) {
		const config = SEGMENT_CONFIGS[this.props.segment] || SEGMENT_CONFIGS['other'];
		const lsPre = config.lsPrefix;
		const filters = getSubFiltersForSegment(this.props.segment, config.defaultStages);
		deleteLocalStorage(lsPre, subFilterKey);
		this.setState({
			subFilters: config.defaultSubFilter,
			buildingStages: config.hasBuildingStages ? config.defaultStages : [],
			orderBy: config.defaultSort,
			order: config.defaultOrder,
			userSorted: false,
			page: 0,
			start: 0,
			tableData: false,
			searchText: '',
			visibleColumns: (() => { try { return JSON.parse(getLocalStorage(lsPre, columnsKey) || 'null') || getDefaultColumns(this.props.segment); } catch(e) { return getDefaultColumns(this.props.segment); } })(),
			selectedUnits: {},
		}, () => {
			this._getInventoryStats();
		});
		return;
	}

	let searchTagsChange = !_isEqual(prevProps.searchTags, this.props.searchTags);
	let buildingStageChange = !_isEqual(prevState.buildingStages, this.state.buildingStages);

	const activeFilters = this._getActiveFilters();
	let subFilterChanged = activeFilters.filter(item => {
		return (
			Array.isArray(item.search_key) ?
				item.search_key.filter(key => this.state.subFilters[key] !== prevState.subFilters[key]).length > 0
			:
				this.state.subFilters[item.search_key] !== prevState.subFilters[item.search_key]
		);
	}).length > 0;

	if (
		this.state.filterBorough !== prevState.filterBorough ||
		this.state.searchText !== prevState.searchText ||
		this.state.orderBy !== prevState.orderBy ||
		this.state.order !== prevState.order ||
		this.state.page !== prevState.page ||
		this.state.rowsPerPage !== prevState.rowsPerPage ||
		searchTagsChange ||
		subFilterChanged ||
		buildingStageChange
	) {
		const resetPage = this.state.page === prevState.page;
		this._getInventoryBuildings(this.props, resetPage, {
			callback: function(response) {
				if (this._getSegment() === 'condos' && response && response.docs) {
					let effective_year = moment().year() - 5;
					response.docs = response.docs.map((doc) => {
						doc["is_completed"] = moment(doc["building_effective_start"]).year() >= effective_year;
						doc["has_sales_started"] = moment(doc["sales_start_date"]).year() > 1969;
						return doc;
					});
				}
				this._formatStats(response, resetPage);
			}.bind(this),
			url: buildingUrl
		});
	}
  }

  handleRequestSort = (event, property) => {
	const orderBy = property;
	let order = 'desc';
	if (this.state.orderBy === property && this.state.order === 'desc') { order = 'asc'; }
	this.setState({ order, orderBy, userSorted: true });
  };

  handleSelectAllClick = (event, checked) => {
	if (checked) {
		const { tableData } = this.state;
		const newSelected = new Map();
		tableData.map(n => newSelected.set(n.id, true));
		this.setState({ selected: newSelected });
		return;
	}
	this.setState({ selected: new Map([]) });
  };

  handleClick = (event, id) => {
	event.stopPropagation();
	const { selected } = this.state;
	const newSelected = new Map(selected);
	const value = newSelected.get(id);
	newSelected.set(id, !value);
	this.setState({ selected: newSelected });
  };

  handleBuildingClick = (event, building) => {
	event.preventDefault();
	event.stopPropagation();
	const buildingURL = _getBuildingURL(building);
	window.open(buildingURL);
  };

  handleChangePage = (event, page) => {
	this.setState({ page: page, start: page * this.state.rowsPerPage });
  };

  handleChangeRowsPerPage = (event) => {
	this.setState({ rowsPerPage: event.target.value, page:0, start:0 });
  };

  isSelected = (id) => {
	const { selected } = this.state;
	return !!selected.get(id);
  };

  // --- Unified Query Construction ---
  _getInventoryBuildings = async (query, resetPage, obj) => {
	const { user } = this.props;
	const segment = this._getSegment();
	const config = this._getConfig();
	const activeFilters = this._getActiveFilters();
	const { buildingStages } = this.state;

	if (!this.state.buildingsFetchInProgress) {
		this.setState({ buildingsFetchInProgress: true });
	}
	const { searchTags } = this.props;

	let locQuery = _tranformTagsQuery(searchTags);

	this.q = "";
	if(locQuery){ this.q += locQuery; }

	this.fq = ["deleted:false"];

	let isExcluded = false;

	// --- Process sub-filters (multi_filter, hierarchical_filter, autocomplete, single) ---
	if (this.state.subFilters && Object.keys(this.state.subFilters).length > 0) {
		Object.keys(this.state.subFilters).map(key => {
			let subFilterVal = this.state.subFilters[key];
			if (subFilterVal && subFilterVal != "") {
				const theFilter = activeFilters.filter(filter => filter.search_key === key);
				if(theFilter && theFilter[0] && (theFilter[0].multi_filter || theFilter[0].hierarchical_filter)){
					const allVals = theFilter[0].hierarchical_filter ? flattenFilterValues(theFilter[0]) : theFilter[0].values;
					const qVal = allVals.length>0 && allVals.filter(value => subFilterVal.indexOf(value.filter)>-1).length>0
								? allVals.filter(value => subFilterVal.indexOf(value.filter)>-1).map(value => value.search_value)
								: null;
					if(qVal!==null){
						if(theFilter[0].target && theFilter[0].target == "fq" && theFilter[0].join_query){
							this.fq.push(`${theFilter[0].join_query}(${qVal.join(" OR ")})`);
						}else{
							this.q += this.q.length > 0 ? " AND " : "";
							if(theFilter[0].no_key){
								this.q += `(${qVal.join(" OR ")})`;
							}else{
								this.q += `(${key}:(${qVal.join(" ")}))`;
							}
						}
					}
				}else if(theFilter && theFilter[0] && theFilter[0].autocomplete){
					const searchKey = theFilter[0].search_key;
					let operator = "AND";
					let searchValue = Array.isArray(subFilterVal) ? subFilterVal : [subFilterVal];
					searchValue = searchValue.map(val => {
						if(val.indexOf("~")>=0){
							const parts = val.split("~");
							operator = parts[parts.length-1];
							return parts[0];
						}
						return val;
					});
					const qVal = searchValue.map(val => `*${val.replace(/[^a-zA-Z0-9]/g, '*')}*`).join(` ${operator} `);
					this.q += this.q.length > 0 ? " AND " : "";
					this.q += `(${searchKey}:(${qVal}))`;
				}else{
					const qVal = theFilter && theFilter.length>0 && theFilter[0].values && theFilter[0].values.length>0 && theFilter[0].values.filter(value => value.filter === subFilterVal).length>0
								? theFilter[0].values.filter(value => value.filter === subFilterVal)[0].search_value
								: null;
					if(qVal!==null){
						if(theFilter[0].target && theFilter[0].target == "fq"){
							this.fq.push(qVal);
						}else{
							this.q += this.q.length > 0 ? " AND " : "";
							// Track excluded status for condos
							if(segment === 'condos' && key === 'offering_verified_status' && ['excluded'].indexOf(qVal)>=0){
								isExcluded = true;
							}
							this.q += `(${key}:${qVal})`;
						}
					}
				}
			}
		});
	}

	// --- Price & Date query ---
	let priceQ = {};
	let replaceKeys = {};

	if (this.state.subFilters && Object.keys(this.state.subFilters).length > 0) {
		Object.keys(this.state.subFilters).map(key => {
			let subFilterVal = this.state.subFilters[key];
			if (subFilterVal && subFilterVal != "") {
				const qArrayFilter = activeFilters.filter(filter => filter.price_filter && Array.isArray(filter.search_key) && filter.search_key.filter(skey => skey === key).length>0);
				if(qArrayFilter.length>0){
					const filterKey = qArrayFilter[0].filter_key;
					if(replaceKeys[filterKey]){
						replaceKeys[filterKey] = [...replaceKeys[filterKey], ...qArrayFilter[0].search_key];
					}else{
						replaceKeys[filterKey] = [...[], ...qArrayFilter[0].search_key];
					}
					if(priceQ[filterKey]){
						let regex = new RegExp(`{${key}}`, "g");
						priceQ[filterKey] = priceQ[filterKey].replace(regex, subFilterVal);
					}else{
						priceQ[filterKey] = qArrayFilter[0].search_value.map(search => search.replace(`{${key}}`, subFilterVal)).join(' OR ');
					}
				}

				const dateArrayFilter = activeFilters.filter(filter => filter.date_filter && Array.isArray(filter.search_key) && filter.search_key.filter(skey => skey === key).length>0);
				if(dateArrayFilter.length>0){
					let dateQ = '';
					let dateReplaceKeys = [];
					dateArrayFilter.forEach(dateF => {
						dateReplaceKeys = [...dateReplaceKeys, ...dateF.search_key];
						if(dateQ){
							let regex = new RegExp(`{${key}}`, "g");
							dateQ = dateQ.replace(regex, moment(subFilterVal).toISOString());
						}else{
							dateQ = dateF.search_value.map(search => search.replace(`{${key}}`, moment(subFilterVal).toISOString())).join(' OR ');
						}
						if(dateQ){
							dateReplaceKeys.map(k => {
								let regex = new RegExp(`{${k}}`, "g");
								dateQ = dateQ.replace(regex, '*');
							});
							this.q += this.q.length > 0 ? " AND " : "";
							this.q += `(${dateQ})`;
						}
					});
				}
			}
		});
	}
	if(priceQ && Object.keys(priceQ).length>0){
		Object.keys(priceQ).map(filterKey => {
			const qArrayFilter = activeFilters.filter(filter => filter.filter_key && filter.filter_key == filterKey)[0];
			replaceKeys[filterKey].map(key => {
				let regex = new RegExp(`{${key}}`, "g");
				if(key.indexOf("min")>=0){
					priceQ[filterKey] = priceQ[filterKey].replace(regex, '0');
				}else{
					if(key.indexOf("max")>=0 && qArrayFilter && qArrayFilter.target=="fq"){
						priceQ[filterKey] = priceQ[filterKey].replace(regex, '99999999');
					}else{
						priceQ[filterKey] = priceQ[filterKey].replace(regex, '*');
					}
				}
			});
			if(qArrayFilter && qArrayFilter.target && qArrayFilter.target =="fq"){
				this.fq.push(priceQ[filterKey]);
			}else{
				this.q += this.q.length > 0 ? " AND " : "";
				this.q += `(${priceQ[filterKey]})`;
			}
		});
	}

	setURLFromState(this.props, this.state);

	// --- Segment-specific FQ ---
	if (segment === 'condos') {
		// Building stage filter
		if(buildingStages && buildingStages.length>0 && buildingStages.indexOf("all")<0){
			this.fq.push(`building_status:("${buildingStages.join("\" OR \"")}")`);
		}
		// Exclude excluded unless explicitly filtering for them
		if(!isExcluded){
			this.fq.push("-offering_verified_status:\"excluded\"");
		}
		// Cohort query
		this.fq.push(getBuildingsCohortForStatuses(user, buildingStages));
		// Non-admin guard
		if(!(user.role && Array.isArray(user.role) && user.role.indexOf('admin')>=0)){
			this.fq.push("total_units:[1 TO *]");
		}
	}
	// Non-condo segments (except "other" = All Buildings): exclude condos/coops/condops
	if (segment !== 'condos' && segment !== 'other') {
		this.fq.push("-ownership_type:(*condo* OR *Condo* OR *CONDO* OR *coop* OR *Coop* OR *COOP* OR *co?op* OR *Co?op* OR *Co?Op* OR *CO?OP* OR *condop* OR *Condop* OR *CONDOP*)");
	}
	// Rental segment: exclude NYCHA/public housing
	if (segment === 'rental') {
		this.fq.push("-ownership_occupancy_sub_types:(public-housing)");
	}
	// Non-condo segments: scoping handled by property_type_filter pre-selection

	// --- Text search ---
	if(this.state.searchText && this.state.searchText.length > 0){
		const text = this.state.searchText.replace(/ /g, '*').toLowerCase();
		const textCaps = _capitalizeText(this.state.searchText.toLowerCase(), false).replace(/ /g, '*');
		this.q += this.q.length > 0 ? " AND " : "";
		this.q += `(name:(*${text}* OR *${textCaps}*) OR display_full_street_address:*${text}* OR neighborhood:*${text}*)`;
	}
	this.q = this.q.length > 0 ? this.q : "*:*";

	// --- Sort ---
	this.sort = `${config.defaultSort} ${config.defaultOrder}`;
	if(config.defaultSort === 'year_built'){
		this.fq.push("year_built:[1700 TO *]");
	}
	if(this.state.userSorted && this.state.orderBy && this.state.orderBy.length > 0){
		if(segment === 'condos'){
			if((this.state.orderBy === 'inventory_unsold') && buildingStages.indexOf('sponsor')<=-1){
				this.sort = `building_status desc, ${this.state.orderBy} ${this.state.order}`;
			}else if((this.state.orderBy === 'inventory_total') && buildingStages.indexOf('sponsor')<=-1){
				this.fq.push("(inventory_total:[1 TO *] OR residential_units:[1 TO *])");
				this.sort = `building_status desc, ${this.state.orderBy} ${this.state.order}`;
			}else if(this.state.orderBy === 'year_built'){
				this.fq.push("year_built:[1700 TO *]");
				this.sort = `${this.state.orderBy} ${this.state.order}`;
			}else{
				this.sort = `${this.state.orderBy} ${this.state.order}`;
			}
		}else{
			if(this.state.orderBy === 'year_built'){
				this.fq.push("year_built:[1700 TO *]");
			}
			this.sort = `${this.state.orderBy} ${this.state.order}`;
		}
	}

	if (query.fq && query.fq.length > 0) {
		this.fq = this.fq.concat(query.fq);
	}

	this.sort = this.sort + ', id asc';

	// --- Facets ---
	let facets = {
		"total_buildings": "unique(key)",
		"total_units": "sum(residential_units)",
	};
	if (segment === 'condos') {
		facets = {
			...facets,
			"total_unsold": "sum(inventory_unsold)",
			"total_inventory_unsold": "sum(inventory_unsold)",
			"total_inventory": "sum(tax_assessed_residential_units)",
			"total_inventory_active" : "sum(inventory_active)",
			"total_inventory_contract" : "sum(inventory_contract)",
			"total_inventory_listed" : "sum(inventory_listed)",
			"total_inventory_shadow" : "sum(inventory_shadow)",
			"total_inventory_sold" : "sum(inventory_sold)",
		};
	} else {
		facets["by_borough"] = {
			"type" : "terms",
			"field" : "borough",
			"limit" : 20,
			"facet" : { "total_units": "sum(residential_units)" }
		};
	}

	let axiosData = {
		url: obj.url + "we3-buildings?cache=15",
		method: "post",
		query: {
			q: this.q,
			fq: this.fq,
			sort: this.sort,
			fl: config.fieldList,
			wt: "json",
			rows: this.state.rowsPerPage,
			start: resetPage ? 0 : this.state.start,
			"json.facet": facets,
		}
	};

	let formattedData = await _axiosCall(axiosData)
		.then(res => {
			if (typeof obj.callback === "function") {
				return obj.callback(res);
			}
		})
		.catch(error => {
			console.log("error: " + error);
		});

	return formattedData;
  };

  _getInventoryStats = () => {
	if (!this.state.buildingsFetchInProgress) {
		this.setState({ buildingsFetchInProgress: true });
	}
	this._getInventoryBuildings(this.props, true, {
		callback: function(response) {
			if (this._getSegment() === 'condos' && response && response.docs) {
				let effective_year = moment().year() - 5;
				response.docs = response.docs.map((doc) => {
					doc["is_completed"] = moment(doc["building_effective_start"]).year() >= effective_year;
					doc["has_sales_started"] = moment(doc["sales_start_date"]).year() > 1969;
					return doc;
				});
			}
			this._formatStats(response, false);
		}.bind(this),
		url: buildingUrl
	});
  };

  _formatStats = (response, resetPage) => {
	if (!response) return;
	let formattedData = response && response.docs && response.docs.slice(0);
	let docs = formattedData.map((doc) => Object.assign({}, doc));

	this.setState({
		buildingsFetchInProgress: false,
		tableData: docs,
		reactTableFiltered: docs,
		originalData: response,
		totalCount: response.numFound,
		start: resetPage ? 0 : this.state.start,
		page: resetPage ? 0 : this.state.page,
		stats: Object.assign({}, this.state.stats, { total_buildings: response.facets ? response.facets.count : 0 }),
		facetData: response.facets,
		selectedUnits: {},
	});
  };

  _filterTableByInput = (name, eValue) => {
	this.setState({searchText: eValue});
  };

  _setSubFilter = (search_key, search_val) => {
	const config = this._getConfig();
	const subF = Object.assign({}, this.state.subFilters, { [search_key]: search_val });
	this.setState({ subFilters: subF, start: 0, end: this.state.rowsPerPage, userSorted: false, orderBy: config.defaultSort, order: config.defaultOrder });
	setLocalStorage(config.lsPrefix, subFilterKey, JSON.stringify(subF));
  }

  _setSubFilters = (subFilters, replace = false) => {
	const config = this._getConfig();
	const subF = replace ? Object.assign({}, subFilters) : Object.assign({}, this.state.subFilters, subFilters);
	this.setState({ subFilters: subF, start: 0, end: this.state.rowsPerPage, userSorted: false, orderBy: config.defaultSort, order: config.defaultOrder });
	setLocalStorage(config.lsPrefix, subFilterKey, JSON.stringify(subF));
  }

  _resetSubFilter = () => {
	const config = this._getConfig();
	const subF = Object.assign({}, config.defaultSubFilter);
	this.setState({ subFilters: subF, start: 0, end: this.state.rowsPerPage, userSorted: false, orderBy: config.defaultSort, order: config.defaultOrder });
	deleteLocalStorage(config.lsPrefix, subFilterKey);
  }

  _resetActive = () => {
	const config = this._getConfig();
	let isDefault = this.props.searchTags.length===0 &&
					_objectEqual(config.defaultSubFilter, this.state.subFilters);
	return !isDefault;
  }

  _selectUnit(property){
	const { selectedUnits } = this.state;
	const newSelected = Object.assign({}, selectedUnits);
	if(newSelected[property.key]){
		delete newSelected[property.key];
	}else{
		newSelected[property.key] = property;
	}
	this.setState( { selectedUnits: Object.assign({}, newSelected) } );
  }

  _handleSelectAllClick(){
	const { selectedUnits, reactTableFiltered } = this.state;
	let newSelected = {};
	if(Object.keys(selectedUnits).length < reactTableFiltered.length){
		reactTableFiltered.forEach(item => { newSelected[item.key] = item; });
	}
	this.setState( { selectedUnits: newSelected } );
  }

  _clearSelectedUnits(){ this.setState({selectedUnits:{}}); }

  _setVisibleColumns = (columns) => {
	const lsPre = this._getConfig().lsPrefix;
	this.setState({ visibleColumns: columns });
	setLocalStorage(lsPre, columnsKey, JSON.stringify(columns));
  }

  _toggleColumnSelector = () => {
	this.setState(prevState => ({ columnSelectorOpen: !prevState.columnSelectorOpen }));
  }

  _toggleViewType = (type) => {
	this.setState({ viewType: type });
  }

  _setBuildingStages = (stage) => {
	const lsPre = this._getConfig().lsPrefix;
	const defaultStages = this._getConfig().defaultStages;
	let newStages = this.state.buildingStages.slice();
	const index = newStages.indexOf(stage);
	const indexAll = newStages.indexOf('all');

	if(index >= 0){
		if(stage === "all"){
			newStages = defaultStages;
		}else{
			newStages.splice(index, 1);
		}
	}else{
		if(stage === "all"){
			newStages = ["all"];
		}else{
			if(indexAll >= 0){
				newStages.splice(indexAll, 1);
			}
			newStages.push(stage);
		}
	}

	if(newStages.length === 0) newStages = ['all'];

	this.setState({ buildingStages: newStages, page: 0, start: 0 });
	setLocalStorage(lsPre, buildingStagesKey, JSON.stringify(newStages));
  }

  _renderCellValue = (d, columnId) => {
	switch(columnId) {
		case 'display_full_street_address':
			return null;
		case 'building_class':
			return d.building_class ? <span className="light-text small-text">{buildingClassDesc[d.building_class] || d.building_class} <span style={{ fontSize: 10, color: '#A3ADC2' }}>({d.building_class})</span></span> : <span className="light-text small-text">--</span>;
		case 'sq_ft':
			return <span className="light-text small-text">{d.sq_ft > 0 ? _formatNumber(d.sq_ft) : '--'}</span>;
		case 'owner':
			return <span className="light-text small-text" style={{whiteSpace:'nowrap'}}>{d.owner ? _capitalizeText(d.owner) : '--'}</span>;
		case 'year_built':
			return <Fragment>
				<span className="light-text small-text">{d.year_built > 1700 ? d.year_built : '--'}{d.year_built > new Date().getFullYear() && <span style={{color:"#858AA1"}}> (Proj)</span>}</span>
				{d.year_converted > 1700 && d.year_converted > d.year_built &&
					<Fragment><br/><span className="light-text small-text" style={{color:"#858AA1"}}>(Conv {d.year_converted})</span></Fragment>
				}
			</Fragment>;
		case 'total_floors':
			return <span className="light-text small-text">{d.total_floors > 0 ? _formatNumber(d.total_floors) : '--'}</span>;
		case 'total_units':
			return <span className="light-text small-text">{d.total_units > 0 ? _formatNumber(d.total_units) : '--'}</span>;
		case 'residential_units':
			return <span className="light-text small-text">{d.residential_units > 0 ? _formatNumber(d.residential_units) : '--'}</span>;
		case 'total_building_floor_area':
			return <span className="light-text small-text">{d.total_building_floor_area > 0 ? _formatNumber(d.total_building_floor_area) : '--'}</span>;
		case 'lot_area':
			return <span className="light-text small-text">{d.lot_area > 0 ? _formatNumber(d.lot_area) : '--'}</span>;
		case 'zoning_district_1':
			return <span className="light-text small-text">{d.zoning_district_1 || '--'}</span>;
		case 'buildable_area': {
			const maxFar = Math.max(d.max_residential_far || 0, d.max_commercial_far || 0, d.max_facility_far || 0);
			const buildable = d.lot_area > 0 && maxFar > 0 ? Math.round(d.lot_area * maxFar) : 0;
			return <span className="light-text small-text">{buildable > 0 ? _formatNumber(buildable) : '--'}</span>;
		}
		case 'last_sold_date_formatted':
			return <span className="light-text small-text">{d.last_sold_date_formatted && moment(d.last_sold_date_formatted).year() > 1970 ? moment(d.last_sold_date_formatted).format('MM/DD/YYYY') : '--'}</span>;
		case 'last_sold_price':
			return <span className="light-text small-text">{d.last_sold_price > 0 ? _formatPrice(d.last_sold_price).toUpperCase() : '--'}</span>;
		case 'ownership_type':
			return <span className="light-text small-text">{d.ownership_type ? _capitalizeText(d.ownership_type.replace(/-/g, ' ').replace(/\?/g, '-')) : '--'}</span>;
		case 'building_status':
			return <span className="light-text small-text">{d.building_status ? _capitalizeText(d.building_status) : '--'}</span>;
		case 'zip':
			return <span className="light-text small-text">{d.zip || '--'}</span>;
		case 'building_category':
			return <span className="light-text small-text">{d.building_category ? _capitalizeText(d.building_category.replace(/-/g, ' ')) : '--'}</span>;
		case 'sales_progress': {
			const pctUnsold = d.inventory_total > 0 ? parseFloat(d.inventory_pct_unsold).toFixed(0) : 0;
			return <SalesProgress progress={pctUnsold} inventory_unsold={d.inventory_unsold} inventory_total={d.inventory_total} min color={d.offering_construction === 'conversion' || d.building_status === 'resale' ? 'grey' : undefined} resale={d.building_status === 'resale'} />;
		}
		case 'inventory_unsold':
			return <span className="light-text small-text">{d.inventory_unsold >= 0 ? _formatNumber(d.inventory_unsold) : '--'}</span>;
		case 'inventory_pct_sold':
			return <span className="light-text small-text">{d.inventory_pct_sold >= 0 ? d.inventory_pct_sold + '%' : '--'}</span>;
		case 'inventory_stats_listings_average_ppsf':
			return <span className="light-text small-text">{d.inventory_stats_listings_average_ppsf > 0 ? '$' + _formatNumber(Math.round(d.inventory_stats_listings_average_ppsf)) : '--'}</span>;
		case 'inventory_stats_transactions_average_ppsf':
			return <span className="light-text small-text">{d.inventory_stats_transactions_average_ppsf > 0 ? '$' + _formatNumber(Math.round(d.inventory_stats_transactions_average_ppsf)) : '--'}</span>;
		case 'developers':
			return <span className="light-text small-text">{d.developers ? _capitalizeText(Array.isArray(d.developers) ? d.developers.join(', ') : d.developers) : '--'}</span>;
		case 'architect':
			return <span className="light-text small-text">{d.architect ? _capitalizeText(Array.isArray(d.architect) ? d.architect.join(', ') : d.architect) : '--'}</span>;
		case 'marketing_company':
			return <span className="light-text small-text">{d.marketing_company ? _capitalizeText(Array.isArray(d.marketing_company) ? d.marketing_company.join(', ') : d.marketing_company) : '--'}</span>;
		case 'last_listed_sale_price_all':
			return <span className="light-text small-text">{d.last_listed_sale_price_all > 0 ? _formatPrice(d.last_listed_sale_price_all).toUpperCase() : '--'}</span>;
		case 'lot_frontage':
			return <span className="light-text small-text">{d.lot_frontage > 0 ? _formatDimension(d.lot_frontage) : '--'}</span>;
		case 'lot_depth':
			return <span className="light-text small-text">{d.lot_depth > 0 ? _formatDimension(d.lot_depth) : '--'}</span>;
		case 'active_listings_sale':
			return <span className="light-text small-text">{d.active_listings_sale > 0 ? _formatNumber(d.active_listings_sale) : '--'}</span>;
		case 'active_listings_rent':
			return <span className="light-text small-text">{d.active_listings_rent > 0 ? _formatNumber(d.active_listings_rent) : '--'}</span>;
		case 'offering_file_number':
			return d.offering_file_number ? (
				<span className="light-text small-text">
					<a href={`https://offeringplandatasearch.ag.ny.gov/REF/planFormServlet?planId=${d.offering_file_number}`} target="_blank" rel="noopener noreferrer" onClick={e => e.stopPropagation()}>
						{d.offering_file_number}
					</a>
				</span>
			) : <span className="light-text small-text">--</span>;
		case 'assessed_land_value':
			return <span className="light-text small-text">{d.assessed_land_value > 0 ? _formatPrice(d.assessed_land_value).toUpperCase() : '--'}</span>;
		case 'assessed_total_value':
			return <span className="light-text small-text">{d.assessed_total_value > 0 ? _formatPrice(d.assessed_total_value).toUpperCase() : '--'}</span>;
		case 'built_far':
			return <span className="light-text small-text">{d.built_far > 0 ? d.built_far.toFixed(2) : '--'}</span>;
		case 'max_residential_far':
			return <span className="light-text small-text">{d.max_residential_far > 0 ? d.max_residential_far.toFixed(2) : '--'}</span>;
		case 'max_commercial_far':
			return <span className="light-text small-text">{d.max_commercial_far > 0 ? d.max_commercial_far.toFixed(2) : '--'}</span>;
		case 'historic_district_name':
			return <span className="light-text small-text">{d.historic_district_name ? _capitalizeText(d.historic_district_name) : '--'}</span>;
		case 'school_district':
			return <span className="light-text small-text">{d.school_district || '--'}</span>;
		case 'sales_start_date':
			return <span className="light-text small-text">{d.sales_start_date && parseInt(moment(d.sales_start_date).format('YYYY')) > 1970 ? moment(d.sales_start_date).format('MM/DD/YYYY') : '--'}</span>;
		default:
			return <span className="light-text small-text">--</span>;
	}
  }

  render() {
	const {
		order, orderBy, selected, rowsPerPage, page, tableData, reactTableFiltered, subFilters, totalCount, buildingsFetchInProgress, stats, selectedUnits, visibleColumns, columnSelectorOpen, viewType, buildingStages
	} = this.state;
	const { user } = this.props;
	const segment = this._getSegment();
	const config = this._getConfig();
	const activeFilters = this._getActiveFilters();
	const activeColumns = this._getActiveColumns();
	const emptyRows = reactTableFiltered ? rowsPerPage - reactTableFiltered.length : 0;
	const tableCount = totalCount;
	const paginationCount = totalCount;

	const filtersForDisplay = (user && user.role && user.role.indexOf('admin')>=0)
		? activeFilters
		: activeFilters.filter(item => !item.admin_only);

	const appBar = (
		<Fragment>
			<SegmentSelector activeSegment={segment} />
			<MatAppBar
				handleSearch={this._filterTableByInput}
				numSelected={[...selected].filter(el => el[1]).length}
				handleDeleteSelected={() => {}}
				onRequestSort={this.handleRequestSort}
				subFilters={subFilters}
				resetSubFilter={this._resetSubFilter}
				setSubFilter={this._setSubFilter}
				setSubFilters={this._setSubFilters}
				_filters={filtersForDisplay}
				numToShow={6}
				placeHolder={'Building, Neighborhood or Borough'}
				buildingAttributes={[]}
				hideBuildingStage={!config.hasBuildingStages}
				goToBuilding={true}
				resetActive={this._resetActive()}
				showExport={!!tableData}
				q={this.q}
				fq={this.fq}
				autocompleteFQ={this.fq}
				fl={buildingExportFL}
				sort={this.sort}
				totalCount={totalCount}
				core_name={"we3-buildings"}
				title={'Export Buildings (CSV)'}
				export_name={'Buildings Search'}
				description={<Fragment><h4><strong>Export this building search for your own analysis.</strong></h4></Fragment>}
				{...(config.hasBuildingStages ? {
					buildingStages: buildingStages,
					_buildingStageFilter: _buildingStageFilter,
					setBuildingStage: this._setBuildingStages,
				} : {})}
			/>
			{config.hasToggleChips && (
				<ToggleChips chipData={allChipData} setSubFilters={this._setSubFilters} subFilters={subFilters} />
			)}
		</Fragment>
	);

	if(!tableData){
		return (
			<Col md={12} lg={12}>
				<Card>
					<CardBody style={{ padding:0 }} >
						{appBar}
						<div style={{padding:"0 10px",clear:"both"}}>
							<LinearLoading />
						</div>
					</CardBody>
				</Card>
			</Col>
		);
	}

	const table = reactTableFiltered;

	return (
		<Col md={12} lg={12}>
			<Card>
				<CardBody style={{ padding:0 }} >
					{appBar}
					<div style={{padding:"0 10px",clear:"both"}}>
						{buildingsFetchInProgress ? <LinearLoading /> : <div style={{height:isMobile ? 0 : 20}} />}
					</div>
					<div className="material-table__header-info">
						<Row style={{ alignItems: 'center' }}>
							<Col md={6} lg={6}>
								<div className={'count_subheader'}>
									<span className="bold-text">{tableCount > 0 ? _formatNumber(tableCount) : '--'}</span>{` `}Buildings
								</div>
							</Col>
							<Col md={6} lg={6} style={{ textAlign:"right", paddingRight: 20, display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 8 }}>
								{(
									<div className="ps-view-toggle" style={{ display: 'inline-flex', border: '1px solid #D1D6E0', borderRadius: 4 }}>
										<Button disabled={viewType === "list"} onClick={() => this._toggleViewType("list")} size="small" startIcon={<ListViewIcon size={14} color={viewType !== "list" ? "#780F9E" : "#A3ADC2"} />} style={{ borderRadius: '4px 0 0 4px', minWidth: 0, padding: '4px 10px' }}>
											<span style={{ fontSize: 12 }}>List</span>
										</Button>
										<div style={{ width: 1, backgroundColor: '#D1D6E0' }} />
										<Button disabled={viewType === "grid"} onClick={() => this._toggleViewType("grid")} size="small" startIcon={<GridViewIcon size={14} color={viewType !== "grid" ? "#780F9E" : "#A3ADC2"} />} style={{ borderRadius: '0 4px 4px 0', minWidth: 0, padding: '4px 10px' }}>
											<span style={{ fontSize: 12 }}>Grid</span>
										</Button>
									</div>
								)}
								<Button
								className="ps-column-selector-btn"
									onClick={this._toggleColumnSelector}
									size="small"
									variant="outlined"
									startIcon={<ColumnsIcon size={14} />}
									style={{ fontSize: 12, color: '#780F9E', borderColor: '#780F9E', marginLeft: 4 }}
								>
									Columns
								</Button>
							</Col>
						</Row>
					</div>

					<Fragment>
						<AddCollectionButton selectedUnits={selectedUnits} groupType={"buildings"} clearSelectedUnits={this._clearSelectedUnits.bind(this)} {...this.props} addMultiple />

						{viewType === 'grid' ? (
							<PropertyGridView data={table} onBuildingClick={this.handleBuildingClick} />
						) : (
						<div className="property-search-table">
						<div className="material-table__wrap" ref={this.tableWrapRef}>
							<Table className="material-table">
								<MatTableHead
									numSelected={Object.keys(selectedUnits).length}
									order={order}
									orderBy={orderBy}
									onSelectAllClick={this._handleSelectAllClick.bind(this)}
									onRequestSort={this.handleRequestSort}
									rowCount={tableData.length}
									visibleColumns={visibleColumns}
									allColumns={activeColumns}
								/>
								<TableBody>
									{table.map((d) => {
										const isSelected = this.isSelected(d.id);
										return (
											<TableRow
												className="material-table__row"
												role="checkbox"
												onClick={event => this.handleBuildingClick(event, d)}
												aria-checked={isSelected}
												tabIndex={-1}
												key={d.id}
												selected={isSelected}
											>
												<TableCell className="material-table__cell ps-table__cell--frozen" padding="none">
													<div className="ps-table__frozen-content">
														<div className="ps-table__checkbox">
															<Checkbox checked={selectedUnits[d.key]===undefined ? false : true} onClick={(e)=>{e.preventDefault();e.stopPropagation(); this._selectUnit(d);}} className={`material-table__checkbox ${selectedUnits[d.key]!==undefined && 'material-table__checkbox--checked'}`} />
														</div>
														<div className="ps-table__photo" style={{ width: 40, height: 40, minWidth: 40, borderRadius: 4, overflow: 'hidden', marginRight: 8, backgroundColor: '#f0f0f0' }}>
															<img src={_getBuildingPhotos(d, '')[0]} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
														</div>
														<div className="ps-table__address">
															<span className={"building_name"}>{d.name ? _capitalizeText(d.name) : _capitalizeText(d.display_full_street_address)}
																<BuildingIcons building={d} />
															</span>
															<br/><span className="light-text small-text">{d.name && _capitalizeText(d.display_full_street_address)+", "} {d.neighborhood && d.neighborhood[0] ? `${_capitalizeText(d.neighborhood[0])}, ` : ''} {_capitalizeText(d.borough)}</span>
														</div>
													</div>
												</TableCell>
												{visibleColumns.filter(colId => colId !== 'display_full_street_address').map(colId => (
													<TableCell
														key={colId}
														className="material-table__cell ps-table__cell--scroll"
														size="small"
													>
														{this._renderCellValue(d, colId)}
													</TableCell>
												))}
											</TableRow>
										);
									})}
									{emptyRows > 0 && (
										<TableRow style={{ height: 49 * emptyRows }}>
											<TableCell colSpan={visibleColumns.length} />
										</TableRow>
									)}
								</TableBody>
							</Table>
						</div>
						<StickyScrollbar scrollContainerRef={this.tableWrapRef} />
						</div>
						)}
						{paginationCount ? <TablePagination
							component="div"
							className="material-table__pagination"
							count={paginationCount}
							rowsPerPage={rowsPerPage}
							page={page}
							backIconButtonProps={{ 'aria-label': 'Previous Page' }}
							nextIconButtonProps={{ 'aria-label': 'Next Page' }}
							onChangePage={this.handleChangePage}
							onChangeRowsPerPage={this.handleChangeRowsPerPage}
							rowsPerPageOptions={[24, 48, 96]}
							dir="ltr"
							SelectProps={{
								inputProps: { 'aria-label': 'rows per page' },
								native: true,
							}}
						/> : null}
					</Fragment>

					<ColumnSelector
						open={columnSelectorOpen}
						onClose={this._toggleColumnSelector}
						visibleColumns={visibleColumns}
						setVisibleColumns={this._setVisibleColumns}
						allColumns={activeColumns}
					/>
				</CardBody>
			</Card>
		</Col>
	);
  }
}

export default connect(state => ({
  user: state.user,
  searchTags: Array.isArray(state.search.searchTags) ? state.search.searchTags.slice() : []
}))(withRouter(BuildingsMatTable));
